import { ChannelType, Expressions, RoomInformation, UserID } from "../../../../types";
import { getAndParseFromLocalStorage, LocalStorageKeys } from "../../../utils/localStorage";
import api from "../../api";
import { serverPath } from "../../config";

export const getSpecificChannelType = (channelType: ChannelType) =>
  api.get(`${serverPath.generateRoomProvider}?videoProvider=${channelType}`);

let sseEmitterId: string | undefined;
export const setSseEmitterId = (id: string) => {
  sseEmitterId = id;
};

export const getAvailableRoom = (signal: AbortSignal) => {
  const data = getAndParseFromLocalStorage(LocalStorageKeys.roomStatistic, {});

  return api.post(
    serverPath.findAvailableRoom,
    {
      ...data,
      status: "ONLINE",
      sseEmitterId,
    },
    { signal }
  );
};

export const getVideoToken = (userId: UserID, friendId: UserID) => {
  const data = getAndParseFromLocalStorage(LocalStorageKeys.roomStatistic, {});

  return api.post(`${serverPath.videoToken}?userId=${userId}&friendId=${friendId}`, {
    ...data,
    status: "ONLINE",
    sseEmitterId,
  });
};

export const updateUserLeaveChannel = (userId: number, speakerDuration?: number, userExpressionAvg?: Expressions) =>
  api.post(serverPath.leaveChannelCallback, {
    userId,
    speakerDuration,
    userExpressionAvg,
    status: "OFFLINE",
    sseEmitterId,
  });

export const userConnected = (roomData: RoomInformation) => api.post(serverPath.userConnected, roomData);

export const cleanChannelCache = () => api.post(serverPath.cleanCache);

export const getAdminChannelToken = (signal: AbortSignal) => api.get(serverPath.findAdminChannelToken, { signal });

export const sendExpressions = (expressions: Expressions, channelName: string) =>
  api.put(serverPath.sendExpressions, { ...expressions, channelName });

export const sendSpeechRecognition = (transcript: string, channelName: string) =>
  api.put(serverPath.sendSpeechRecognition, { transcript, channelName });

export const kickOutUser = (userId: number | string) => api.post(`${serverPath.kickOut}?userId=${userId}`);

export const saveToNotifiersList = () => api.put(serverPath.saveToNotifiersList);
